import { render, staticRenderFns } from "./custom_detail.vue?vue&type=template&id=cb97e1f6&scoped=true"
import script from "./custom_detail.vue?vue&type=script&lang=js"
export * from "./custom_detail.vue?vue&type=script&lang=js"
import style0 from "./custom_detail.vue?vue&type=style&index=0&id=cb97e1f6&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb97e1f6",
  null
  
)

export default component.exports